module.exports = __webpack_public_path__ + "static/media/AuratMarchBack.402f08ca.jpg";